<template>
    <a-popover v-model="visible" placement="bottomLeft" trigger="click" :overlayStyle="popoverOverlayStyle">
        <div slot="content" v-if="!disabled" :style="{ width: width + 'px' }">
            <template v-if="!hideExpand">
                <div @click="showLeftDepartment" class="byDep" v-if="!showDirectory">
                    <a-icon type="left" />展开组织架构
                </div>
                <div @click="showLeftDepartment" class="byDep" v-else>
                    收起组织架构
                    <a-icon type="right" />
                </div>
            </template>
            <a-input
                placeholder="搜索姓名"
                v-model="queryParam.fullName"
                allowClear
                @input="onSearch"
                @change="onSearch"
                @pressEnter="onSearch"
            >
                <a-icon slot="prefix" type="search" style="color: #999" />
            </a-input>

            <!-- <a-button @click="searchReset(1)" style="margin-left: 10px" icon="redo" size="small"></a-button> -->
            <section class="box">
                <div v-show="showDirectory" class="organ">
                    <!--组织机构-->
                    <a-directory-tree v-if="departTree.length" selectable :selectedKeys="selectedDepIds"
                        :replace-fields="replaceFields" :checkStrictly="true" @select="onDepSelect"
                        :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }" :treeData="departTree"
                        :showIcon="false" defaultExpandAll />
                </div>

                <div class="modalContent">
                    <!--status(1：正常  2：冻结 ）-->

                    <!-- <a-tabs default-active-key="1" @change="handleStatusTab">
                        <a-tab-pane key="1" tab="正常"></a-tab-pane>
                        <a-tab-pane key="2" tab="冻结"></a-tab-pane>
                        <a-tab-pane key="0" tab="全部"></a-tab-pane>
                    </a-tabs> -->
                    <!--用户列表-->
                    <a-row v-if="multiple && dataSource.length > 1">
                        <a-col :span="24">
                            <a-checkbox :indeterminate="indeterminate" @change="onCheckAllChange"
                                :checked="checkAll">全选</a-checkbox>
                        </a-col>
                    </a-row>
                    <a-spin :spinning="loading">
                        <a-checkbox-group :value="selectValue">
                            <a-row v-for="item in filterMemberList" :key="item.id" style="margin: 6px 0">
                                <a-col :span="24">
                                    <a-checkbox :value="normalizeModelValue(item[valueField])" @change="chackboxChange"
                                        :disabled="item.username == exclude">
                                        <a-avatar :src="item.avatar | fullAvatar" size="small"
                                            v-if="item.avatar"></a-avatar>
                                        <a-avatar size="small" style="background-color: #007aff !important" v-else>{{
                                            item.fullName | splitFirstFilter
                                            }}</a-avatar>
                                        {{ item.fullName }}
                                        <!-- <span v-if="item.status == '2'" style="color: #f5222d">(冻结)</span> -->
                                        <a-tag color="blue" v-if="item.id == userid()">我自己</a-tag>
                                    </a-checkbox>
                                </a-col>
                            </a-row>
                        </a-checkbox-group>
                        <a-empty :image="simpleImage" v-if="!filterMemberList.length" description="暂无数据" />
                    </a-spin>
                </div>
            </section>
            <div class="footer">
                <span>
                    已选
                    <b>{{ selectValue ? selectValue.length : 0 }}</b> 条
                </span>
                <div style="text-align: center">
                    <a-pagination v-model="ipagination.current" :total="ipagination.total" size="small" hideOnSinglePage
                        :pageSize="ipagination.pageSize" @change="handleTableChange" />
                </div>
                <div>
                    <a href="javascript:" @click="clear">清空</a>
                    <a href="javascript:" @click="handleOk">确认</a>
                </div>
            </div>
        </div>
        <a-select :mode="multiple ? 'multiple' : 'default'" :placeholder="placeholder" v-model="selectValue"
            :open="false" allowClear :options="selectOptions" :disabled="disabled" @change="selectChange"
            style="min-width: 180px" />
        <div style="display: none"></div>
        <!-- :options="selectOptions" -->
    </a-popover>
</template>

<!-- 
    分页获取用户的接口地址(get)：/sys/user/queryList
    只返回id,fullName,avatar,initial,status
-->
<script>
import { filterObj, getTreeMenu } from '@/utils/util'
import { Empty } from 'ant-design-vue'
// import { postAction } from '@/api/manage'
import { mapGetters } from 'vuex'
import { USER_INFO } from '@/store/mutation-types'
import Vue from 'vue'
export default {
    name: 'SelectMemberModal',
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        //控制权限
        auditLevel: {
            type: Number,
            default: null,
        },
        //传过来的值
        isCheckAll: {
            type: Boolean,
            default: false,
        },
        onlyLeader: {
            type: Boolean,
            default: false,
        },

        isCheckMold: {
            type: Boolean,
            default: false,
        },
        multiple: {
            // 是否多选
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            // default: '+请选择',
        },
        triggerChange: {
            // 是要change还是input方式emit
            type: Boolean,
            default: false,
        },
        disabled: {
            // disabled
            type: Boolean,
            default: false,
        },
        // queryParam:Object,
        value: [String, Array], //传进来的值
        dictText: {
            //传进来的中文，避免出现ID,但对于多选来说就无效了，没办法传多个中文进来。。。所以目前的解决办法是不分页。
            type: Object,
            default: () => { },
        },
        exclude: {
            // 要排除的人id
            type: String,
            default: '',
        },
        hideExpand: {
            type: Boolean,
            default: () => {
                const userInfoCache = Vue.ls.get(USER_INFO) || {}
                if (userInfoCache.isSubCompany) {
                    return true
                } else {
                    return false
                }
            },
        },
        departmentIds: {
            type: Array,
            default: () => {
                const userInfoCache = Vue.ls.get(USER_INFO) || {}
                let deptId = userInfoCache.deptId
                if (deptId) {
                    return [deptId]
                } else {
                    return []
                }
            },
        },
        exceptDeptIds: {
            type: Array,
            default: () => [],
        },
        deptId: {
            type: [Number, String],
            default: null,
        },
        valueField: {
            type: String,
            default: 'username', // 'username' or 'fullName'
        },
        /** 在 el-drawer / Modal 等高层级容器内使用时传入，避免弹层被遮挡 */
        popoverZIndex: {
            type: Number,
            default: undefined,
        },
    },
    data() {
        return {
            visible: false,
            checkAll: false,
            indeterminate: true,
            departmentInfo: {},
            selectUserRows: [],
            selectUserIds: [],
            selectValue: [],
            selectRealname: '',
            dictOptions: [],
            selectOptions: [],
            nowRealname: '',
            dataSource: [],
            allUserData: [],
            queryParam: {
                // status: 1, //1：正常  2：冻结
                column: 'initial',
                order: 'asc',
            },
            ipagination: {
                current: 1,
                pageSize: 999,
                showTotal: (total, range) => {
                    return range[0] + '-' + range[1] + ' 共' + total + '条'
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0,
            },
            selectedRowKeys: '',
            radioStyle: {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
            },
            loading: false,
            showDirectory: false,
            departTree: [],
            selectedDepIds: [],
            replaceFields: {
                children: 'children',
                title: 'deptName',
                key: 'deptId',
                value: 'deptId',
            },
            simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
            width: 300,
            // filterMemberList:[],
            tabkey: 1,
        }
    },
    computed: {
        popoverOverlayStyle() {
            if (this.popoverZIndex != null) {
                return { zIndex: this.popoverZIndex }
            }
            return {}
        },
        /**
         * 可选名单（支持按姓名/账号本地过滤）
         */
        filterMemberList() {
            let list = this.dataSource || []
            if (this.tabkey != 0) {
                // return this.dataSource.filter(item => item.status == this.tabkey) 区分用户状态
            }
            const keyword = ((this.queryParam && this.queryParam.fullName) || '').trim().toLowerCase()
            if (!keyword) {
                return list
            }
            return list.filter((item) => {
                const fullName = String((item && item.fullName) || '').toLowerCase()
                const username = String((item && item.username) || '').toLowerCase()
                return fullName.indexOf(keyword) !== -1 || username.indexOf(keyword) !== -1
            })
        },
        /**
         * 当前页已选名单
         */
        selectedMemberOnCurData() {
            const key = this.valueField
            const curDataSet = new Set(this.dataSource.map((v) => String(v[key])))
            return this.selectValue.filter((v) => curDataSet.has(String(v)))
        },
    },
    watch: {
        value() {
            this.syncSelectValueFromProp()
            this.checkAll = this.filterMemberList.length === this.selectedMemberOnCurData.length
            this.indeterminate =
                !!this.selectedMemberOnCurData.length &&
                this.selectedMemberOnCurData.length < this.filterMemberList.length

            //数组类型，需要转换为对象数组 [{fullName, username}]
            let sendChangeData = []
            if (this.selectValue && this.selectValue.length > 0 && this.allUserData.length > 0) {
                sendChangeData = this.selectValue.map((val) => {
                    const user = this.findUserByValue(val)
                    if (user) {
                        return {
                            id: user.id || '',
                            fullName: user.fullName || '',
                            username: user.username || val,
                            account: user.username || ''
                        }
                    }
                    return {
                        id: '',
                        fullName: '',
                        username: val
                    }
                })
            }
            this.$emit('SendChange', sendChangeData)
            this.$emit('send-change', sendChangeData)
            // console.log('当前页所选', sendChangeData)
        },
        // selectValue() {

        // },
    },

    methods: {
        ...mapGetters(['userid', 'userInfo']),
        normalizeModelValue(value) {
            if (value === undefined || value === null || value === '') return ''
            return String(value)
        },
        isSameValue(a, b) {
            if (a === undefined || a === null || b === undefined || b === null) return false
            return String(a) === String(b)
        },
        findUserByValue(val) {
            return this.allUserData.find((v) => this.isSameValue(v[this.valueField], val))
        },
        normalizePermissionGroupResponse(res = {}) {
            const payload = res && res.data && typeof res.data === 'object' ? res.data : res
            return {
                userList: Array.isArray(payload.userList) ? payload.userList : [],
                roleList: Array.isArray(payload.roleList) ? payload.roleList : [],
                deptTreeList: Array.isArray(payload.deptTreeList) ? payload.deptTreeList : [],
            }
        },
        mergeSelectOptions(options = []) {
            const map = new Map()
            options.forEach((option) => {
                if (!option || option.value === undefined || option.value === null || option.value === '') return
                const key = String(option.value)
                if (!map.has(key)) {
                    map.set(key, {
                        label: option.label || key,
                        value: key,
                    })
                }
            })
            this.selectOptions = Array.from(map.values())
        },
        applyPermissionGroupData(groupData = {}, keepCurrentDep = false) {
            this.dataSource = groupData.userList || []
            this.allUserData = groupData.userList || []
            this.ipagination.total = this.dataSource.length
            this.departTree = groupData.deptTreeList || []
            if (!keepCurrentDep || this.selectedDepIds.length === 0) {
                if (this.deptId !== null && this.deptId !== undefined && this.deptId !== '') {
                    this.selectedDepIds = [this.deptId]
                } else if (this.departTree.length > 0) {
                    const firstDept = this.departTree[0]
                    this.selectedDepIds = firstDept && firstDept.deptId != null ? [firstDept.deptId] : []
                } else {
                    this.selectedDepIds = []
                }
            }
            const options = this.allUserData.map((data) => ({
                label: data.fullName || data.username || data.id,
                value: this.normalizeModelValue(data[this.valueField]),
            }))
            this.mergeSelectOptions([...this.selectOptions, ...options])
            this.checkAll = this.filterMemberList.length === this.selectedMemberOnCurData.length
            this.indeterminate =
                !!this.selectedMemberOnCurData.length &&
                this.selectedMemberOnCurData.length < this.filterMemberList.length
        },
        syncSelectValueFromProp() {
            const v = this.value
            if (this.multiple) {
                if (!v) {
                    this.selectValue = []
                } else if (Array.isArray(v)) {
                    this.selectValue = [...new Set(v
                        .map((item) => {
                            if (item != null && typeof item === 'object') {
                                if (item[this.valueField] != null) return item[this.valueField]
                                if (item.username != null) return item.username
                            }
                            return item
                        })
                        .filter((x) => x !== undefined && x !== null && x !== '')
                        .map((x) => this.normalizeModelValue(x)))]
                } else if (typeof v === 'string') {
                    this.selectValue = [...new Set(v.split(',').filter(Boolean).map((x) => this.normalizeModelValue(x)))]
                } else {
                    this.selectValue = [this.normalizeModelValue(v)]
                }
            } else if (!v) {
                this.selectValue = []
            } else if (typeof v === 'object') {
                const x = v[this.valueField] != null ? v[this.valueField] : v.username
                this.selectValue = x ? [this.normalizeModelValue(x)] : []
            } else {
                this.selectValue = [this.normalizeModelValue(v)]
            }
        },

        //切换状态
        handleStatusTab(key) {
            // this.queryParam.status = key
            this.tabkey = key
            // if(key == 0){
            //     this.filterMemberList=this.dataSource
            // }else{
            //     this.filterMemberList=this.dataSource.filter(item=>item.status==key)

            // }
            // this.loadData(1)
        },

        showLeftDepartment() {
            if (this.showDirectory) {
                // 收起组织架构 → 查全部人员
                this.loadAllUsers(1)
                this.width = 300
            } else {
                this.initQueryUserByDepId(this.selectedDepIds[0])
                this.width = 600
            }
            this.showDirectory = !this.showDirectory
        },

        // 点击树节点,筛选出对应的用户
        onDepSelect(selectedDepIds) {
            console.log('selectDepId', selectedDepIds)

            if (selectedDepIds[0] != null) {
                this.initQueryUserByDepId(selectedDepIds[0]) // 调用方法根据选选择的id查询用户信息
                if (this.selectedDepIds[0] !== selectedDepIds[0]) {
                    this.selectedDepIds = [selectedDepIds[0]]
                }
            }
        },
        // 根据选择的id来查询用户信息
        initQueryUserByDepId(selectedDepIds) {
            this.loading = true
            this.$HttpService
                .post('/permission/getPermissionGroup', {
                    deptId: selectedDepIds,
                })
                .then((res) => {
                    const groupData = this.normalizePermissionGroupResponse(res)
                    this.applyPermissionGroupData(groupData, true)
                    this.ipagination.total = this.filterMemberList.length
                })
                .finally(() => {
                    this.loading = false
                })
        },

        // 查询组织架构信息
        queryDepartTree() {
            this.$HttpService.post('/permission/getPermissionGroup').then((res) => {
                const groupData = this.normalizePermissionGroupResponse(res)
                this.departTree = groupData.deptTreeList
                if (this.selectedDepIds.length === 0) {
                    if (this.deptId !== null && this.deptId !== undefined && this.deptId !== '') {
                        this.selectedDepIds = [this.deptId]
                    } else if (this.departTree.length > 0) {
                        const firstDept = this.departTree[0]
                        this.selectedDepIds = firstDept && firstDept.deptId != null ? [firstDept.deptId] : []
                    }
                }
            })
        },

        // 这个方法主要搜用于在外面点X，或者allowClear全部清除
        selectChange(value, option) {
            console.log('ss', value)

            if (value && !value.length) {
                // this.checkAll = false
            }
            this.selectValueFn()
        },
        selectValueFn() {
            let value
            if (this.multiple) {
                value = (this.selectValue && this.selectValue.join()) || '' //数组变字符串
            } else {
                value = this.selectValue ? this.selectValue.toString() : ''
            }

            if (this.allUserData.length && value) {
                if (this.multiple) {
                    let valueArr = value.split(',')
                    let fullNameStr = ''
                    valueArr.forEach((val) => {
                        const user = this.findUserByValue(val)
                        if (user) {
                            fullNameStr += user.fullName
                        }
                    })
                    this.$emit('transfer', fullNameStr)
                } else {
                    const user = this.findUserByValue(value)
                    if (user) {
                        this.$emit('transfer', user.fullName)
                    }
                }
            }
            if (this.triggerChange) {
                this.$emit('change', value)
            } else {
                this.$emit('input', value)
            }
        },
        clear() {
            this.selectValue = []
            // this.checkAll = false
            this.selectValueFn()
        },
        onSearch() {
            const keyword = ((this.queryParam && this.queryParam.fullName) || '').trim()
            this.ipagination.current = 1
            if (keyword) {
                // 有关键字：拉全量后由 filterMemberList 本地过滤
                this.loadAllUsers(1)
                return
            }
            // 清空搜索：未展开组织树时查全部；展开时按当前选中部门
            if (this.showDirectory && this.selectedDepIds && this.selectedDepIds[0] != null) {
                this.initQueryUserByDepId(this.selectedDepIds[0])
            } else {
                this.loadAllUsers(1)
            }
        },

        chackboxChange(e) {
            // 选中人员
            let chackedValue = e.target.value
            let status = e.target.checked
            if (this.multiple) {
                // 多选
                this.selectValue.push(this.normalizeModelValue(chackedValue))
                if (status) {
                    // 取消选中后去重
                    this.selectValue = [...new Set(this.selectValue)]
                } else {
                    const targetValue = this.normalizeModelValue(chackedValue)
                    this.selectValue = this.selectValue.filter((item) => item !== targetValue)
                }
            } else {
                // 单选
                this.visible = true
                this.selectValue = [this.normalizeModelValue(chackedValue)]
            }
            this.selectValueFn()
        },
        onCheckAllChange(e) {
            // 全选
            console.log('全选', e)
            // Object.assign(this, {
            //     selectValue: e.target.checked ? this.filterMemberList.map((item) => item.username) : [],
            // })
            let selectedMemberList = [...this.selectValue]
            const field = this.valueField
            if (e.target.checked) {
                //选中，过滤
                this.selectValue = [
                    ...new Set([...selectedMemberList, ...this.filterMemberList.map((item) => this.normalizeModelValue(item[field]))]),
                ]
            } else {
                //取消选中
                const pageValSet = new Set(this.filterMemberList.map((item) => String(item[field])))
                this.selectValue = selectedMemberList.filter((v) => !pageValSet.has(String(v)))
            }
            this.selectValueFn()
        },

        /** 加载全部用户（不按部门过滤） */
        loadAllUsers(arg) {
            this.loading = true
            if (arg === 1) {
                this.ipagination.current = 1
            }
            this.$HttpService
                .post('/permission/getPermissionGroup', {})
                .then((res) => {
                    const groupData = this.normalizePermissionGroupResponse(res)
                    this.applyPermissionGroupData(groupData, true)
                    this.ipagination.total = this.filterMemberList.length
                })
                .finally(() => {
                    this.loading = false
                })
        },

        // 加载用户：默认/收起组织树 → 全部；展开组织树 → 当前部门
        loadData(arg) {
            if (this.showDirectory && this.selectedDepIds && this.selectedDepIds[0] != null) {
                if (arg === 1) {
                    this.ipagination.current = 1
                }
                this.initQueryUserByDepId(this.selectedDepIds[0])
                return
            }
            this.loadAllUsers(arg)
        },
        getAllUserData() {
            // this.$HttpService.post('/sysuser/listusers', {})
            //     .then((res) => {
            //         if (res.code === 200) {
            //             this.allUserData = res.data
            //             let options = this.allUserData.map((data) => ({
            //                 label: data.fullName,
            //                 value: data[this.valueField]
            //             }))
            //             this.selectOptions = options
            //         }
            //     })
            //     .finally(() => {
            //         //this.loading = false
            //     })
        },
        getQueryParams() {
            let param = Object.assign({}, this.queryParam, this.isorter)
            if (param.fullName) param.fullName = `*${param.fullName}*`
            param.field = 'id,fullName'
            param.pageNo = this.ipagination.current
            param.pageSize = this.ipagination.pageSize
            return filterObj(param)
        },
        // getMember(argument) {
        // 	console.log(argument)

        // 	this.selectUserIds = argument[0].toString()
        // 	this.selectUserRows = argument[1]
        // },
        handleTableChange(current, size) {
            // 翻页
            this.ipagination.current = current
            this.loadData()
        },

        handleOk() {
            this.visible = true
            let value = (this.selectValue && this.selectValue.join()) || '' //数组变字符串
            console.log(this.selectValue)
            this.$emit('input', value)
            this.$emit('change', value)


        },
    },
    created() {
        this.queryDepartTree()
        this.loadData()

        this.syncSelectValueFromProp()

        // 默认把自己的姓名也翻译出来，
        const userInfo = this.userInfo || Vue.ls.get(USER_INFO) || {}
        const selfValue =
            userInfo[this.valueField] != null
                ? userInfo[this.valueField]
                : userInfo.username
        if (selfValue !== undefined && selfValue !== null && selfValue !== '') {
            this.mergeSelectOptions([...this.selectOptions, {
                label: userInfo.fullName || 'Unknown Name',
                value: this.normalizeModelValue(selfValue),
            }])
        }

        // 如果传了dictText也要加进去，避免中文在非第一页的时候就不显示中文
        // console.log(this.dictText.label);
        // if(this.dictText.label){
        // 	this.selectOptions.push(this.dictText)
        // }
    },
}
</script>

<style scoped lang="less">
@primary-color: #1890ff;

.timeUl {
    overflow: hidden;
    flex-wrap: wrap;
    align-content: flex-start;
    padding-left: 0;
    display: flex;

    li {
        list-style: none;
        float: left;
        flex: 0 0 33.333333%;
        cursor: pointer;
        padding: 2px 10px;
        margin: 5px;
        border-radius: 5px;

        span {
            padding: 2px 10px;
            border-radius: 4px;
        }

        &.active {
            span {
                color: #fff;
                background-color: @primary-color;
            }

            .anticon {
                transform: rotate(180deg);
            }
        }

        &:last-child {
            width: 100%;
            background-color: #f4f6fc;
            margin: 0;
            flex: none;
            color: #91959e;
            border-radius: 0;

            span {
                color: #91959e;
                background-color: #f4f6fc;
            }

            .anticon {
                margin-top: 3px;
            }
        }
    }
}

/deep/ .ant-modal-body {
    padding: 0 !important;
}

.customBox {
    text-align: center;
}

/deep/ .ant-input {
    border-radius: 500px;
    background-color: rgb(245, 245, 245);
    border: none;
}

/deep/ .ant-card-body {
    padding: 0;
}

.byDep {
    padding-left: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    color: #999;
}

.box {
    display: flex;
}

.modalContent {
    width: 310px;
    height: 342px !important;
    overflow-y: auto;
    padding: 2px 0 20px 0;
}

.organ {
    flex: 1;
    height: 318px;
    overflow-y: auto;
    margin-right: 12px;
}

.footer {
    position: absolute;
    bottom: 0;
    border-top: 1px solid #e8e8e8;
    background-color: #fafafa;
    height: 36px;

    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    left: 0;
    right: 0;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;

    a {
        margin-left: 8px;
    }
}

/deep/ .ant-select-selection--multiple {
    padding-bottom: 0;
    //height: 32px;
}

.card-container {
    background: #f5f5f5;
}
</style>
